import React from 'react';
import ArticleLink from './models/ArticleLink';
import TitledArticleLinkCardList from './components/TitledArticleCardList';
import { ArticleLinkCardStyle } from './components/ArticleLinkCard';
import { blogEndpoint } from './Blog';
import getPreviewMode from '@gik/core/utils/PreviewMode';

interface RelatedArticlesContainerProps {
  articleLinks: ArticleLink[];
}

export default class RelatedArticlesContainer extends React.PureComponent<RelatedArticlesContainerProps> {
  render() {
    return (
      <div className="blog related-articles">
        <TitledArticleLinkCardList
          title="Related Articles"
          articleLinks={this.props.articleLinks
            .filter(article => !article.isPreviewOnly || article.isPreviewOnly === getPreviewMode())
            .slice(0, 3)}
          style={ArticleLinkCardStyle.smallHorizontal}
          hidePrimaryTaxonomy
        />
        <a href={`/${blogEndpoint}`} className="btn btn-block btn-outline btn-second upper">
          <i className="inkind-icon icon-article"></i> see all articles
        </a>
      </div>
    );
  }
}
